import { LadzoConsole as Lc } from "./ladzo-console.js";
export function uprav_datove_typy() {
  Lc.f("uprav_datove_typy");
  if (typeof String.prototype.prevedNaCislo !== "function") {
    String.prototype.prevedNaCislo = function() {
      var $text = this;
      $text = $text.replace(",", ".");
      $text = $text.replace(" ", "");
      // eslint-disable-next-line
      $text = Number($text.replace(/[^0-9\.-]+/g, ""));
      return $text;
    };
  }

  /*
param pocet desetinnych mist
param oddelovač desetinnych mist
param oddelovač tisicu
zobrazovat i dve nuly, napr 5,00 misto 5
*/
  if (typeof Number.prototype.formatCisla !== "function") {
    Number.prototype.formatCisla = function(
      c = 2,
      d = ",",
      t = " ",
      u = false
    ) {
      var n = this,
        s = n < 0 ? "-" : "",
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
        j = (j = i.length) > 3 ? j % 3 : 0;
      var $r =
        s +
        (j ? i.substr(0, j) + t : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);

      var $zbytek = c
        ? Math.abs(n - i)
            .toFixed(c)
            .slice(2)
        : 0;
      var $rep = "0".repeat(c);

      if (!u && $rep == $zbytek) {
        return $r;
      }
      $r += c
        ? d +
          Math.abs(n - i)
            .toFixed(c)
            .slice(2)
        : "";

      //var $r=  s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
      return $r;
    };
  }
  //"50Kč".replace(/[^0-9\.-]+/g, "")
  //retezce
  /*
  if (typeof String.prototype.replaceAll !== "function") {
    String.prototype.replaceAll = function(search, replacement) {
      var target = this;
      return target.replace(new RegExp(search, "g"), replacement);
    };
  }
  */
  /*
  Number.prototype.prevedNaEuro = function() {
    var num = this;

    var kurz = getShoptetDataLayer("currencyInfo").exchangeRate;
    var $c = num * kurz;

    //var $c= num * (1 / window.kurz);

    return Math.round($c * 10) / 10;
  };
  */
}
